<template>
  <svg
    :x="svgCoords.x"
    :y="svgCoords.y"
    viewBox="0 0 236.1 284"
    width="400"
    height="350"
    id="milestone-redirect"
    class="redirect"
    role="img"
  >
    <g class="computer">
      <path class="a" d="M202.1,48h-1.2V81.4h1.2Z" transform="translate(-0.1 -0.4)" />
      <path class="a" d="M201.6,137.1h-1.3v11.8h1.3Z" transform="translate(-0.1 -0.4)" />
      <path
        class="a"
        d="M1.5,160.1H.1v-38s-.8-12,10.4-17l.5,1.2c-10.3,4.6-9.7,15.3-9.7,15.8Z"
        transform="translate(-0.1 -0.4)"
      />
      <path class="a" d="M1.3,164.7H.1v12.8H1.3Z" transform="translate(-0.1 -0.4)" />
      <path
        class="a"
        d="M161.5,196.1l-7,.2-.4-.2-26.9-15.5a6,6,0,0,0-5.5-.2L60.5,215.8h-.2L40,222.7c-.4.1-.5.3-.5.7v5.1a2,2,0,0,0,1.3,2.1l33.7,19.5a6,6,0,0,0,5.5.2l81-46.8a1.6,1.6,0,0,0,1.1-1.4v-5C162.2,196.5,161.9,196.1,161.5,196.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M77.9,251.3a7.8,7.8,0,0,1-3.4-.9L40.8,230.9a2.7,2.7,0,0,1-1.7-2.7v-5A1.3,1.3,0,0,1,40,222l20.3-6.9,61.1-35.4a7.5,7.5,0,0,1,6.2.2l26.9,15.5,7-.2a2.5,2.5,0,0,1,1.1.4,1.2,1.2,0,0,1,.3.9v5a2.2,2.2,0,0,1-1.2,1.9l-81,46.7A3.4,3.4,0,0,1,77.9,251.3Zm46.2-70.7a3.9,3.9,0,0,0-2,.5L61,216.5h-.2l-20.3,6.9v5.4c-.2.5.3,1,1,1.4l33.7,19.4a5.5,5.5,0,0,0,5,.2l81-46.7c.3-.2.7-.5.7-.9v-5l-7.1.2a.8.8,0,0,1-.7-.2l-26.9-15.5A4,4,0,0,0,124.1,180.6Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="b"
        d="M161.4,197.8,80.3,244.6a6.3,6.3,0,0,1-5.5-.2L41.2,224.9c-1.7-1-1.9-2.4-.4-3.3l81.1-46.7c1.4-.9,3.9-.7,5.5.2L161,194.6C162.6,195.4,162.8,197,161.4,197.8Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M77.9,245.8a7.8,7.8,0,0,1-3.4-.9L40.8,225.4a3.2,3.2,0,0,1-1.7-2.4,2.1,2.1,0,0,1,1.2-1.9l81.1-46.7a6.8,6.8,0,0,1,6.2.2L161.2,194a3.4,3.4,0,0,1,1.7,2.5,2.2,2.2,0,0,1-1.2,1.9l-81,46.7A5.5,5.5,0,0,1,77.9,245.8Zm46.2-70.9a3.9,3.9,0,0,0-2,.5L41,222.1c-.3.2-.7.6-.7.9s.4.9,1.1,1.2L75,243.7a5.5,5.5,0,0,0,5,.2l81-46.8a.9.9,0,0,0,.7-.8,1.4,1.4,0,0,0-1-1.2l-33.6-19.5A7.3,7.3,0,0,0,124.1,174.9Z"
        transform="translate(-0.1 -0.4)"
      />
      <path class="c" d="M159.1,199.6h-1v4.8h1Z" transform="translate(-0.1 -0.4)" />
      <path
        class="b"
        d="M195.7,12.5v-.4l-6-3.3a1.5,1.5,0,0,0-1.3,0L6.7,113.7A4.1,4.1,0,0,0,5,117.1v139c0,.7.1,1.2.5,1.4l6.4,3.4,6.3-7.5-2.5-1.1,172.7-99.6a4.1,4.1,0,0,0,1.8-3.5V20Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M11.9,261.8,5.1,258a2.1,2.1,0,0,1-.8-1.9v-139a4.7,4.7,0,0,1,2-3.9L188.1,8.3a2.1,2.1,0,0,1,1.9,0l5.9,3.3c.1.2.3.3.3.5a1,1,0,0,1-.2.7l-5.3,7.4v129a4.9,4.9,0,0,1-2.1,4L17,252.3l2.1.9ZM189,9.4h-.4L7,114.4a3.4,3.4,0,0,0-1.3,2.7v139a1.1,1.1,0,0,0,.3.9l5.9,3.3,5.3-6.6-2.9-1.2L188.1,152.1a3.2,3.2,0,0,0,1.4-2.7V19.7l5.3-7.2-5.5-3.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M194.7,156.1,13.1,261c-1.1.5-1.8,0-1.8-1.4V120.8a4.8,4.8,0,0,1,1.8-3.5L194.7,12.5c1-.6,1.7,0,1.7,1.3v139A3.6,3.6,0,0,1,194.7,156.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M12.4,261.8a1.5,1.5,0,0,1-.9-.2,2.2,2.2,0,0,1-.8-2V120.8a4.8,4.8,0,0,1,2-4l181.6-105a1.8,1.8,0,0,1,1.7-.2q.9.5.9,2.1v139a4.8,4.8,0,0,1-2.1,3.9L13.4,261.6A1.8,1.8,0,0,1,12.4,261.8Zm182.9-249c-.1,0-.3,0-.3.2L13.4,117.8a3.5,3.5,0,0,0-1.4,2.8v139c0,.5.2.8.4.8s.3,0,.5-.1L194.3,155.6a3.2,3.2,0,0,0,1.4-2.8V13.7c.2-.6,0-.7-.4-.9Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="c"
        d="M194.5,153.5,13.4,258c-.3.2-.5,0-.5-.3V120.1a1.4,1.4,0,0,1,.5-1.1L194.5,14.5c.3-.1.5,0,.5.4V152.7C195,153,194.7,153.3,194.5,153.5Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M13.1,258.9c-.2,0-.4,0-.5-.2a1,1,0,0,1-.6-1V120.1a2,2,0,0,1,.9-1.6L194,14a.9.9,0,0,1,1,0,1.1,1.1,0,0,1,.5,1V152.8a1.9,1.9,0,0,1-.8,1.6L13.6,258.9C13.4,258.7,13.2,258.9,13.1,258.9ZM194.3,15.2,13.6,119.5a.9.9,0,0,0-.2.6V257.3L194.1,153a.8.8,0,0,0,.2-.5Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M196.6,153v-7.9L11.3,252v7.9a1.2,1.2,0,0,0,1.9,1.1L194.7,156.3A4.5,4.5,0,0,0,196.6,153Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M12.4,261.8a1.5,1.5,0,0,1-.9-.2,2,2,0,0,1-.8-1.7v-8.3H11L197.2,144v9.2A4.9,4.9,0,0,1,195,157L13.4,261.5A1.3,1.3,0,0,1,12.4,261.8Zm-.5-9.5v7.6a5.6,5.6,0,0,0,.1.7,1.1,1.1,0,0,0,.7-.2L194.3,155.6a3.4,3.4,0,0,0,1.6-2.8v-6.9Z"
        transform="translate(-0.1 -0.4)"
      />
      <path class="c" d="M115.3,196.3,91.9,209.9l.5.8,23.4-13.5Z" transform="translate(-0.1 -0.4)" />
      <path class="a" d="M5.2,114.6l-.6,1.1,6.2,3.7.6-1Z" transform="translate(-0.1 -0.4)" />
      <path
        class="a"
        d="M77.6,242.2a3.1,3.1,0,0,1-1.9-.6l-7.1-4.3.7-1,7.1,4.3a2.1,2.1,0,0,0,2.4,0l69.6-39.8.7,1L79.3,241.6A2.9,2.9,0,0,1,77.6,242.2Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M151.2,200.8l-.7-1.2,5.2-3a.4.4,0,0,0,.2-.3s0-.4-.2-.4l-7.3-4.1.7-1,7.3,4.1a1.8,1.8,0,0,1,.8,1.6,1.8,1.8,0,0,1-.8,1.5Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="b"
        d="M173.8,113.9,36.4,193.2c-2.3,1.4-4.2,0-4.2-3.1V173.7c0-3.1,1.9-6.6,4.2-7.9L173.8,86.4c2.2-1.3,4.1,0,4.1,3.1v16.4A10.4,10.4,0,0,1,173.8,113.9Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M31.2,200.2a2.9,2.9,0,0,1-1.4-.3,4.7,4.7,0,0,1-1.7-4V179.7c0-3.2,1.9-7,4.5-8.4L170,92a3.3,3.3,0,0,1,3.3-.2,4.7,4.7,0,0,1,1.7,3.9v16.4c0,3.3-1.9,7.1-4.5,8.5L33.1,199.9A5.4,5.4,0,0,1,31.2,200.2ZM172.1,92.5a2.6,2.6,0,0,0-1.4.3L33.2,172.1c-2,1.2-3.7,4.5-3.7,7.5v16.3c0,1.4.3,2.5,1,2.8a2.2,2.2,0,0,0,2.1-.2L170,119.2c2.1-1.2,3.8-4.5,3.8-7.4V95.4a3.3,3.3,0,0,0-1-2.8Z"
        transform="translate(-0.1 -0.4)"
      />
      <path class="a" d="M4.9,121.3l-.6,1.1,6.2,3.7.7-1Z" transform="translate(-0.1 -0.4)" />
      <path
        class="a"
        d="M85.7,201.5a7.6,7.6,0,0,1-1.8,3.1c.2,0,1.6-.2,1.8,1a6.1,6.1,0,0,1,1.7-3.1C87.2,202.5,85.8,202.7,85.7,201.5Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M90.8,198.5a5.7,5.7,0,0,1-1.7,3.1c.2,0,1.6-.1,1.7,1.1a6.3,6.3,0,0,1,1.8-3.1C92.4,199.6,91,199.7,90.8,198.5Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M96,195.6a7,7,0,0,1-1.7,3.1c.2,0,1.5-.2,1.7,1a9.1,9.1,0,0,1,1.7-3.1c-.1,0-1.5.2-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M101.2,192.5a8.2,8.2,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a7,7,0,0,1,1.7-3.1C102.7,193.5,101.4,193.7,101.2,192.5Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M106.4,189.6a7.6,7.6,0,0,1-1.8,3.1c.2,0,1.6-.2,1.8,1a6.1,6.1,0,0,1,1.7-3.1C107.9,190.6,106.5,190.8,106.4,189.6Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M111.5,186.6a5.7,5.7,0,0,1-1.7,3.1c.2,0,1.6-.1,1.7,1.1a6.3,6.3,0,0,1,1.8-3.1C113.1,187.7,111.7,187.8,111.5,186.6Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M116.7,183.7a7,7,0,0,1-1.7,3.1c.2,0,1.5-.2,1.7,1a9.1,9.1,0,0,1,1.7-3.1c-.1,0-1.5,0-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M121.9,180.6a8.2,8.2,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a7.7,7.7,0,0,1,1.7-3.1C123.4,181.6,122.1,181.8,121.9,180.6Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M127.1,177.7a7.6,7.6,0,0,1-1.8,3.1c.2,0,1.6-.2,1.8,1a6.1,6.1,0,0,1,1.7-3.1C128.6,178.7,127.2,178.9,127.1,177.7Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M132.1,174.7a6.3,6.3,0,0,1-1.8,3.1c.2,0,1.6-.1,1.8,1.1a5.7,5.7,0,0,1,1.7-3.1s-1.4.1-1.7-1.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M80.5,204.6a9.1,9.1,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a7,7,0,0,1,1.7-3.1c-.2,0-1.5,0-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M85.7,195.6a6.9,6.9,0,0,1-1.8,3.1c.2,0,1.6-.2,1.8,1a6.6,6.6,0,0,1,1.7-3.1c-.2,0-1.6,0-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M90.8,192.5a6.1,6.1,0,0,1-1.7,3.1c.2,0,1.6-.2,1.7,1a6.9,6.9,0,0,1,1.8-3.1C92.4,193.5,91,193.7,90.8,192.5Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M96,189.6a7.7,7.7,0,0,1-1.7,3.1c.2,0,1.5-.2,1.7,1a8.2,8.2,0,0,1,1.7-3.1C97.6,190.6,96.2,190.8,96,189.6Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M101.2,186.6a7.4,7.4,0,0,1-1.7,3.1c.1,0,1.5-.1,1.7,1.1a6.4,6.4,0,0,1,1.7-3.1c-.2,0-1.5.1-1.7-1.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M106.4,183.5a6.3,6.3,0,0,1-1.8,3.1c.2,0,1.6-.1,1.8,1.1a5.7,5.7,0,0,1,1.7-3.1C107.9,184.6,106.5,184.7,106.4,183.5Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M111.5,180.6a6.1,6.1,0,0,1-1.7,3.1c.2,0,1.6-.2,1.7,1a7.6,7.6,0,0,1,1.8-3.1C113.1,181.6,111.7,181.8,111.5,180.6Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M116.7,177.7a7.7,7.7,0,0,1-1.7,3.1c.2,0,1.5-.2,1.7,1a8.2,8.2,0,0,1,1.7-3.1C118.3,178.7,116.9,178.9,116.7,177.7Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M121.9,174.7a7.4,7.4,0,0,1-1.7,3.1c.1,0,1.5-.1,1.7,1.1a6.4,6.4,0,0,1,1.7-3.1c-.2,0-1.5,0-1.7-1.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M127.1,171.6a6.3,6.3,0,0,1-1.8,3.1c.2,0,1.6-.1,1.8,1.1a5.7,5.7,0,0,1,1.7-3.1C128.6,172.7,127.2,172.8,127.1,171.6Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M132.1,168.7a6.9,6.9,0,0,1-1.8,3.1c.2,0,1.6-.2,1.8,1a6.6,6.6,0,0,1,1.7-3.1s-1.4.2-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M70.2,204.4a6.9,6.9,0,0,1-1.8,3.1c.2,0,1.6-.2,1.8,1a6.1,6.1,0,0,1,1.7-3.1C71.7,205.4,70.3,205.6,70.2,204.4Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M75.3,201.5a6.6,6.6,0,0,1-1.7,3.1c.2,0,1.6-.2,1.7,1a8.2,8.2,0,0,1,1.7-3.1C76.9,202.5,75.5,202.7,75.3,201.5Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M80.5,198.5a7.4,7.4,0,0,1-1.7,3.1c.1,0,1.5-.1,1.7,1.1a6.4,6.4,0,0,1,1.7-3.1C82,199.6,80.7,199.7,80.5,198.5Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M85.7,189.6a7.6,7.6,0,0,1-1.8,3.1c.2,0,1.6-.2,1.8,1a6.1,6.1,0,0,1,1.7-3.1C87.2,190.6,85.8,190.8,85.7,189.6Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M90.8,186.6a5.7,5.7,0,0,1-1.7,3.1c.2,0,1.6-.1,1.7,1.1a6.3,6.3,0,0,1,1.8-3.1c-.2,0-1.6,0-1.8-1.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M96,183.5a6.4,6.4,0,0,1-1.7,3.1c.2,0,1.5-.1,1.7,1.1a7.4,7.4,0,0,1,1.7-3.1C97.6,184.6,96.2,184.7,96,183.5Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M101.2,180.6a8.2,8.2,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a7.7,7.7,0,0,1,1.7-3.1C102.7,181.6,101.4,181.8,101.2,180.6Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M106.4,177.7a7.6,7.6,0,0,1-1.8,3.1c.2,0,1.6-.2,1.8,1a6.1,6.1,0,0,1,1.7-3.1c-.2,0-1.6.2-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M111.5,174.6a6.6,6.6,0,0,1-1.7,3.1c.2,0,1.6-.2,1.7,1a6.9,6.9,0,0,1,1.8-3.1C113.1,175.6,111.7,175.8,111.5,174.6Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M116.7,171.6a6.4,6.4,0,0,1-1.7,3.1c.2,0,1.5-.1,1.7,1.1a7.4,7.4,0,0,1,1.7-3.1C118.3,172.7,116.9,172.8,116.7,171.6Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M121.9,168.7a8.2,8.2,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a7.7,7.7,0,0,1,1.7-3.1C123.4,169.7,122.1,169.9,121.9,168.7Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M127.1,165.8a7.6,7.6,0,0,1-1.8,3.1c.2,0,1.6-.2,1.8,1a6.1,6.1,0,0,1,1.7-3.1c-.2,0-1.6,0-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M132.1,162.7a7.6,7.6,0,0,1-1.8,3.1c.2,0,1.6-.2,1.8,1a6.1,6.1,0,0,1,1.7-3.1s-1.4.2-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M59.8,204.4a7,7,0,0,1-1.7,3.1c.2,0,1.5-.2,1.7,1a8.2,8.2,0,0,1,1.7-3.1C61.4,205.4,60.1,205.6,59.8,204.4Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M65,201.5a9.1,9.1,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a6.1,6.1,0,0,1,1.7-3.1A1.4,1.4,0,0,1,65,201.5Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M70.2,198.5a6.3,6.3,0,0,1-1.8,3.1c.2,0,1.6-.1,1.8,1.1a5.7,5.7,0,0,1,1.7-3.1c-.2,0-1.6.1-1.7-1.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M75.3,195.4a5.7,5.7,0,0,1-1.7,3.1c.2,0,1.6-.1,1.7,1.1a7.4,7.4,0,0,1,1.7-3.1C76.9,196.5,75.5,196.6,75.3,195.4Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M80.5,192.5a8.2,8.2,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a7,7,0,0,1,1.7-3.1C82,193.5,80.7,193.7,80.5,192.5Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M85.7,183.5a6.3,6.3,0,0,1-1.8,3.1c.2,0,1.6-.1,1.8,1.1a5.7,5.7,0,0,1,1.7-3.1C87.2,184.6,85.8,184.7,85.7,183.5Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M90.8,180.6a6.1,6.1,0,0,1-1.7,3.1c.2,0,1.6-.2,1.7,1a7.6,7.6,0,0,1,1.8-3.1C92.4,181.6,91,181.8,90.8,180.6Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M96,177.7a7.7,7.7,0,0,1-1.7,3.1c.2,0,1.5-.2,1.7,1a8.2,8.2,0,0,1,1.7-3.1c-.1,0-1.5,0-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M101.2,174.6a9.1,9.1,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a7,7,0,0,1,1.7-3.1C102.7,175.6,101.4,175.8,101.2,174.6Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M106.4,171.6a6.3,6.3,0,0,1-1.8,3.1c.2,0,1.6-.1,1.8,1.1a5.7,5.7,0,0,1,1.7-3.1C107.9,172.7,106.5,172.8,106.4,171.6Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M111.5,168.7a6.1,6.1,0,0,1-1.7,3.1c.2,0,1.6-.2,1.7,1a7.6,7.6,0,0,1,1.8-3.1c-.2,0-1.6.2-1.8-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M116.7,165.6a7,7,0,0,1-1.7,3.1c.2,0,1.5-.2,1.7,1a8.2,8.2,0,0,1,1.7-3.1C118.3,166.6,116.9,166.8,116.7,165.6Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M121.9,162.7a9.1,9.1,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a7,7,0,0,1,1.7-3.1C123.4,163.7,122.1,163.9,121.9,162.7Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M127.1,159.7a6.3,6.3,0,0,1-1.8,3.1c.2,0,1.6-.1,1.8,1.1a5.7,5.7,0,0,1,1.7-3.1C128.6,160.8,127.2,160.9,127.1,159.7Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M132.1,156.8a6.9,6.9,0,0,1-1.8,3.1c.2,0,1.6-.2,1.8,1a6.6,6.6,0,0,1,1.7-3.1s-1.4,0-1.7-1S132.1,156.6,132.1,156.8Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M137.2,171.6a5.7,5.7,0,0,1-1.7,3.1c.2,0,1.6-.1,1.7,1.1a6.3,6.3,0,0,1,1.8-3.1,1.8,1.8,0,0,1-1.8-1.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M142.4,168.7a7,7,0,0,1-1.7,3.1c.2,0,1.5-.2,1.7,1a9.1,9.1,0,0,1,1.7-3.1C144,169.7,142.7,169.9,142.4,168.7Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M147.6,165.8a9.1,9.1,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a6.1,6.1,0,0,1,1.7-3.1A1.4,1.4,0,0,1,147.6,165.8Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M152.8,162.8a6.3,6.3,0,0,1-1.8,3.1c.2,0,1.6-.1,1.8,1.1a5.7,5.7,0,0,1,1.7-3.1c-.2,0-1.6,0-1.7-1.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M137.2,165.8a6.6,6.6,0,0,1-1.7,3.1c.2,0,1.6-.2,1.7,1a6.9,6.9,0,0,1,1.8-3.1,1.7,1.7,0,0,1-1.8-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M142.4,162.7a7.7,7.7,0,0,1-1.7,3.1c.2,0,1.5-.2,1.7,1a8.2,8.2,0,0,1,1.7-3.1C144,163.7,142.7,163.9,142.4,162.7Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M147.6,159.7a7.4,7.4,0,0,1-1.7,3.1c.1,0,1.5-.1,1.7,1.1a5.7,5.7,0,0,1,1.7-3.1A1.5,1.5,0,0,1,147.6,159.7Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M152.8,156.8a6.9,6.9,0,0,1-1.8,3.1c.2,0,1.6-.2,1.8,1a6.6,6.6,0,0,1,1.7-3.1C154.3,157.8,152.9,158,152.8,156.8Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M137.2,159.7a5.7,5.7,0,0,1-1.7,3.1c.2,0,1.6-.1,1.7,1.1a6.3,6.3,0,0,1,1.8-3.1,1.8,1.8,0,0,1-1.8-1.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M142.4,156.8a7,7,0,0,1-1.7,3.1c.2,0,1.5-.2,1.7,1a9.1,9.1,0,0,1,1.7-3.1c-.1,0-1.4.2-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M147.6,153.7a8.2,8.2,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a6.1,6.1,0,0,1,1.7-3.1A1.4,1.4,0,0,1,147.6,153.7Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M152.8,150.8a7.6,7.6,0,0,1-1.8,3.1c.2,0,1.6-.2,1.8,1a6.1,6.1,0,0,1,1.7-3.1C154.3,151.8,152.9,152,152.8,150.8Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M137.2,153.7a6.1,6.1,0,0,1-1.7,3.1c.2,0,1.6-.2,1.7,1a6.9,6.9,0,0,1,1.8-3.1,1.7,1.7,0,0,1-1.8-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M142.4,150.8a7.7,7.7,0,0,1-1.7,3.1c.2,0,1.5-.2,1.7,1a8.2,8.2,0,0,1,1.7-3.1C144,151.8,142.7,152,142.4,150.8Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M147.6,147.8a7.4,7.4,0,0,1-1.7,3.1c.1,0,1.5-.1,1.7,1.1a5.7,5.7,0,0,1,1.7-3.1,1.5,1.5,0,0,1-1.7-1.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M152.8,144.7a6.3,6.3,0,0,1-1.8,3.1c.2,0,1.6-.1,1.8,1.1a5.7,5.7,0,0,1,1.7-3.1C154.3,145.8,152.9,145.9,152.8,144.7Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M49.5,204.4a6.9,6.9,0,0,1-1.8,3.1c.2,0,1.6-.2,1.8,1a6.1,6.1,0,0,1,1.7-3.1s-1.4.2-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M54.6,201.5a6.6,6.6,0,0,1-1.7,3.1c.2,0,1.6-.2,1.7,1a6.9,6.9,0,0,1,1.8-3.1A1.7,1.7,0,0,1,54.6,201.5Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M59.8,198.5a6.4,6.4,0,0,1-1.7,3.1c.2,0,1.5-.1,1.7,1.1a7.4,7.4,0,0,1,1.7-3.1c-.1,0-1.4,0-1.7-1.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M65,195.4a7.4,7.4,0,0,1-1.7,3.1c.1,0,1.5-.1,1.7,1.1a5.7,5.7,0,0,1,1.7-3.1A1.5,1.5,0,0,1,65,195.4Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M70.2,192.5a6.9,6.9,0,0,1-1.8,3.1c.2,0,1.6-.2,1.8,1a6.1,6.1,0,0,1,1.7-3.1C71.7,193.5,70.3,193.7,70.2,192.5Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M75.3,189.6a6.6,6.6,0,0,1-1.7,3.1c.2,0,1.6-.2,1.7,1a8.2,8.2,0,0,1,1.7-3.1c-.1,0-1.5.2-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M80.5,186.5a9.1,9.1,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a7,7,0,0,1,1.7-3.1C82,187.5,80.7,187.7,80.5,186.5Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M85.7,86.8a6.9,6.9,0,0,1-1.8,3.1c.2,0,1.6-.2,1.8,1a6.1,6.1,0,0,1,1.7-3.1A1.2,1.2,0,0,1,85.7,86.8Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M90.8,83.9A6.6,6.6,0,0,1,89.1,87c.2,0,1.6-.2,1.7,1a6.9,6.9,0,0,1,1.8-3.1C92.4,84.9,91,85.1,90.8,83.9Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M96,80.9A6.4,6.4,0,0,1,94.3,84c.2,0,1.5-.1,1.7,1.1A7.4,7.4,0,0,1,97.7,82C97.6,82,96.2,82.1,96,80.9Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M101.2,78a8.2,8.2,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a7,7,0,0,1,1.7-3.1c-.2,0-1.5.2-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M106.4,74.9a6.9,6.9,0,0,1-1.8,3.1c.2,0,1.6-.2,1.8,1a6.1,6.1,0,0,1,1.7-3.1C107.9,75.9,106.5,76.1,106.4,74.9Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M111.5,72a6.6,6.6,0,0,1-1.7,3.1c.2,0,1.6-.2,1.7,1a6.9,6.9,0,0,1,1.8-3.1C113.1,73,111.7,73.2,111.5,72Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M116.7,69a6.4,6.4,0,0,1-1.7,3.1c.2,0,1.5-.1,1.7,1.1a7.4,7.4,0,0,1,1.7-3.1C118.3,70.1,116.9,70.2,116.7,69Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M121.9,65.9a8.2,8.2,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1.1a6.4,6.4,0,0,1,1.7-3.1A1.4,1.4,0,0,1,121.9,65.9Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M127.1,63a6.9,6.9,0,0,1-1.8,3.1c.2,0,1.6-.2,1.8,1a6.1,6.1,0,0,1,1.7-3.1C128.6,64,127.2,64.2,127.1,63Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M132.1,60.1a7.6,7.6,0,0,1-1.8,3.1c.2,0,1.6-.2,1.8,1a6.1,6.1,0,0,1,1.7-3.1s-1.4.2-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M34.1,116.6a7,7,0,0,1-1.7,3.1c.2,0,1.5-.2,1.7,1.1a7.4,7.4,0,0,1,1.7-3.1C35.7,117.7,34.3,117.8,34.1,116.6Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M39.3,113.7a8.2,8.2,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a7,7,0,0,1,1.7-3.1C40.8,114.7,39.5,114.9,39.3,113.7Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M44.3,110.8a9.1,9.1,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a7,7,0,0,1,1.7-3.1s-1.4.2-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M49.5,107.6a7.4,7.4,0,0,1-1.8,3.2c.2,0,1.6-.2,1.8,1a6.1,6.1,0,0,1,1.7-3.1c0,.2-1.4.2-1.7-1.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M54.6,104.7a6.1,6.1,0,0,1-1.7,3.1c.2,0,1.6-.2,1.7,1.1a6.3,6.3,0,0,1,1.8-3.1A1.8,1.8,0,0,1,54.6,104.7Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M59.8,101.8a7,7,0,0,1-1.7,3.1c.2,0,1.5-.2,1.7,1a8.2,8.2,0,0,1,1.7-3.1C61.4,102.8,60.1,103,59.8,101.8Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M65,98.9a9.1,9.1,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a6.1,6.1,0,0,1,1.7-3.1,1.4,1.4,0,0,1-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M70.2,95.7a7.4,7.4,0,0,1-1.8,3.2c.2,0,1.6-.2,1.8,1a6.1,6.1,0,0,1,1.7-3.1C71.7,96.8,70.3,97,70.2,95.7Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M75.3,92.8a6.1,6.1,0,0,1-1.7,3.1c.2,0,1.6-.2,1.7,1.1A7.4,7.4,0,0,1,77,93.9C76.9,93.9,75.5,94,75.3,92.8Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M80.5,89.9A8.2,8.2,0,0,1,78.8,93c.1,0,1.5-.2,1.7,1a7,7,0,0,1,1.7-3.1C82,90.9,80.7,91.1,80.5,89.9Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M85.7,80.9A6.3,6.3,0,0,1,83.9,84c.2,0,1.6-.1,1.8,1.1A5.7,5.7,0,0,1,87.4,82C87.2,82,85.8,82.1,85.7,80.9Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M90.8,77.8a6.1,6.1,0,0,1-1.7,3.1c.2,0,1.6-.2,1.7,1.1a7.4,7.4,0,0,1,1.8-3.2A1.3,1.3,0,0,1,90.8,77.8Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M96,74.9A7,7,0,0,1,94.3,78c.2,0,1.5-.2,1.7,1a8.2,8.2,0,0,1,1.7-3.1C97.6,75.9,96.2,76.1,96,74.9Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M101.2,72a9.1,9.1,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a7,7,0,0,1,1.7-3.1C102.7,73,101.4,73.2,101.2,72Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M106.4,69a6.3,6.3,0,0,1-1.8,3.1c.2,0,1.6-.1,1.8,1.1a5.7,5.7,0,0,1,1.7-3.1c-.2,0-1.6.1-1.7-1.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M111.5,65.9a6.1,6.1,0,0,1-1.7,3.1c.2,0,1.6-.2,1.7,1.1a6.3,6.3,0,0,1,1.8-3.1C113.1,67,111.7,67.1,111.5,65.9Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M116.7,63a7,7,0,0,1-1.7,3.1c.2,0,1.5-.2,1.7,1a8.2,8.2,0,0,1,1.7-3.1C118.3,64,116.9,64.2,116.7,63Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M121.9,60.1a9.1,9.1,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a7,7,0,0,1,1.7-3.1C123.4,61.1,122.1,61.3,121.9,60.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M127.1,56.9a7.4,7.4,0,0,1-1.8,3.2c.2,0,1.6-.2,1.8,1a6.1,6.1,0,0,1,1.7-3.1A1.2,1.2,0,0,1,127.1,56.9Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M132.1,54a6.9,6.9,0,0,1-1.8,3.1c.2,0,1.6-.2,1.8,1.1a5.7,5.7,0,0,1,1.7-3.1s-1.4.1-1.7-1.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M34.1,110.8a7.7,7.7,0,0,1-1.7,3.1c.2,0,1.5-.2,1.7,1a8.2,8.2,0,0,1,1.7-3.1c-.1,0-1.5.2-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M39.3,107.6a8.8,8.8,0,0,1-1.7,3.2c.1,0,1.5-.2,1.7,1a7,7,0,0,1,1.7-3.1C40.8,108.7,39.5,108.9,39.3,107.6Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M44.3,104.7a8.2,8.2,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1.1a6.4,6.4,0,0,1,1.7-3.1s-1.4.1-1.7-1.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M49.5,101.8a6.9,6.9,0,0,1-1.8,3.1c.2,0,1.6-.2,1.8,1a6.1,6.1,0,0,1,1.7-3.1s-1.4.2-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M54.6,98.7a6.1,6.1,0,0,1-1.7,3.1c.2,0,1.6-.2,1.7,1a6.9,6.9,0,0,1,1.8-3.1C56.4,99.9,55,99.9,54.6,98.7Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M59.8,95.7a7.5,7.5,0,0,1-1.7,3.2c.2,0,1.5-.2,1.7,1a8.2,8.2,0,0,1,1.7-3.1A1.5,1.5,0,0,1,59.8,95.7Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M65,92.8a8.2,8.2,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1.1a5.7,5.7,0,0,1,1.7-3.1A1.5,1.5,0,0,1,65,92.8Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M70.2,89.9A6.9,6.9,0,0,1,68.4,93c.2,0,1.6-.2,1.8,1a6.1,6.1,0,0,1,1.7-3.1c-.2,0-1.6.2-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M75.3,86.8a6.1,6.1,0,0,1-1.7,3.1c.2,0,1.6-.2,1.7,1A8.2,8.2,0,0,1,77,87.8C76.9,87.8,75.5,88,75.3,86.8Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M80.5,83.9A9.1,9.1,0,0,1,78.8,87c.1,0,1.5-.2,1.7,1a7,7,0,0,1,1.7-3.1C82,84.9,80.7,85.1,80.5,83.9Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M137.2,57.1a5.7,5.7,0,0,1-1.7,3.1c.2,0,1.6-.1,1.7,1.1a6.3,6.3,0,0,1,1.8-3.1,1.8,1.8,0,0,1-1.8-1.1C137.4,56.9,137.2,56.9,137.2,57.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M142.4,54a7,7,0,0,1-1.7,3.1c.2,0,1.5-.2,1.7,1.1a7.4,7.4,0,0,1,1.7-3.1A1.6,1.6,0,0,1,142.4,54Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M147.6,51.1a8.2,8.2,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a6.1,6.1,0,0,1,1.7-3.1A1.4,1.4,0,0,1,147.6,51.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M152.8,48.2a7.6,7.6,0,0,1-1.8,3.1c.2,0,1.6-.2,1.8,1a6.1,6.1,0,0,1,1.7-3.1C154.3,49.2,152.9,49.4,152.8,48.2Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M137.2,51.1a6.1,6.1,0,0,1-1.7,3.1c.2,0,1.6-.2,1.7,1a6.9,6.9,0,0,1,1.8-3.1,1.7,1.7,0,0,1-1.8-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M142.4,48.2a7.7,7.7,0,0,1-1.7,3.1c.2,0,1.5-.2,1.7,1a8.2,8.2,0,0,1,1.7-3.1c-.1,0-1.4.2-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M147.6,45.1a9.1,9.1,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a6.1,6.1,0,0,1,1.7-3.1A1.4,1.4,0,0,1,147.6,45.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M152.8,42.1a6.3,6.3,0,0,1-1.8,3.1c.2,0,1.6-.1,1.8,1.1a5.7,5.7,0,0,1,1.7-3.1C154.3,43.2,152.9,43.3,152.8,42.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M156.4,118.3v16.6c0,.2.1.2.1,0l3.1-5.2c0-.2.2-.2.2,0l2.4,3.8h.2l1.7-2.1h0l-2.4-4a.2.2,0,0,1,.2-.2l4.6-2.7c.2,0,.2-.2,0-.4l-10.1-6C156.5,118,156.4,118.2,156.4,118.3Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M156.4,135.4l-.4-.2V118.3l.4-.5h.5l10.3,6.2v.4a.9.9,0,0,1-.3.5l-4.7,2.4,2.3,3.8a.7.7,0,0,1-.2.7l-1.7,2.1h-.7l-2.1-3.5-2.7,4.8A2,2,0,0,0,156.4,135.4Zm.3-16.7v15.2l2.6-4.4c.2-.1.3-.3.5-.3h.2l.2.2,2.2,3.4,1.4-1.7-2.3-3.8V127a.4.4,0,0,1,.4-.4l4.5-2.6Z"
        transform="translate(-0.1 -0.4)"
      />
      <path class="c" d="M51.3,177.8l-11.8,6.9.6,1,11.8-6.8Z" transform="translate(-0.1 -0.4)" />
      <path class="b" d="M37.9,187.7l11.7-6.9Z" transform="translate(-0.1 -0.4)" />
      <path class="a" d="M49.5,180.4l-11.8,6.8.6,1.1,11.8-6.9Z" transform="translate(-0.1 -0.4)" />
      <path
        class="a"
        d="M73.8,160.1V157l1.2-.7a1,1,0,0,1,1.2-.2c.3.2.3.5.3,1a3.2,3.2,0,0,1-.3,1.4c-.2.4-.7.7-1,1.1Zm1.2-5.9-3.6,2.1v12l2.4-1.3v-4.7l1.4-.7a1.4,1.4,0,0,1,1.2-.2c.3.2.3.6.3,1.1v.7a3,3,0,0,0,.2,1.2c0,.3.1.7.3.7l2.6-1.4v-.2c-.2,0-.3-.3-.5-.5s-.2-.7-.2-1v-.7a5.7,5.7,0,0,0-.3-1.6c-.4-.3-.7-.3-1.4-.1a6.7,6.7,0,0,0,1.2-1.9,4.4,4.4,0,0,0,.3-1.9c0-1.1-.3-1.8-1-2.1S76.2,153.5,75,154.2Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M89.1,146.1l-6.9,4V162l6.9-4v-2.1l-4.5,2.6v-3.1l3.7-2.1v-2l-3.7,2v-2.5l4.5-2.6Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M94.3,152.8v-7.7l1.4-.9a1.2,1.2,0,0,1,1.4,0,2.6,2.6,0,0,1,.5,1.7v2.3a5.4,5.4,0,0,1-.5,2.2,5.6,5.6,0,0,1-1.4,1.6Zm1.4-10.5-3.8,2.3v12l3.8-2.2a9.2,9.2,0,0,0,3.1-3.1A8.5,8.5,0,0,0,100,147v-2.3c0-1.4-.4-2.4-1.2-2.7A2.5,2.5,0,0,0,95.7,142.3Z"
        transform="translate(-0.1 -0.4)"
      />
      <path class="a" d="M105.5,136.6l-2.4,1.4v11.9l2.4-1.4Z" transform="translate(-0.1 -0.4)" />
      <path
        class="a"
        d="M111.2,138.5v-3.1l1.2-.7a1.4,1.4,0,0,1,1.2-.2c.4.2.4.6.4,1.1a4.3,4.3,0,0,1-.4,1.4,6.3,6.3,0,0,1-1.2,1Zm1.2-5.8-3.6,2v12.1l2.4-1.4v-4.6l1.4-.7a1,1,0,0,1,1.2-.2,1.3,1.3,0,0,1,.3,1v.7a2.7,2.7,0,0,0,.2,1.2c0,.4.2.7.3.7l2.5-1.4h0c-.2,0-.4-.4-.4-.7a2.2,2.2,0,0,1-.2-1.1v-.6a3.2,3.2,0,0,0-.3-1.6c-.4-.3-.7-.3-1.4-.2a4.7,4.7,0,0,0,1.2-1.9,3,3,0,0,0,.4-1.9,2,2,0,0,0-1.1-2C114.6,131.6,113.6,131.8,112.4,132.7Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M126.5,124.5l-6.9,3.8v12.1l6.9-4v-2l-4.4,2.4v-2.9l3.6-2.1v-2.3l-3.6,2.3v-2.6l4.4-2.6Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M133.3,120.4a7.5,7.5,0,0,0-3,3.1,9.6,9.6,0,0,0-1.2,4.2v2.5c0,1.6.4,2.5,1.2,3s1.9.3,3.1-.5a10.1,10.1,0,0,0,3-2.8,6.1,6.1,0,0,0,1-3.6l-2.4,1.4a4.3,4.3,0,0,1-.4,1.7,3.3,3.3,0,0,1-1.2,1.2,1,1,0,0,1-1.3,0,2.2,2.2,0,0,1-.6-1.7v-2.6a4.4,4.4,0,0,1,.6-2.3,2.6,2.6,0,0,1,1.2-1.5c.7-.4,1-.5,1.3-.4s.4.7.4,1.4l2.4-1.4c0-1.3-.3-2.2-1-2.4A3.8,3.8,0,0,0,133.3,120.4Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M147.2,112.5l-7.9,4.6v2.1l2.8-1.6v9.9l2.4-1.4v-9.8l2.7-1.6Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M44.3,207.3a7.4,7.4,0,0,1-1.7,3.1c.1,0,1.5-.1,1.7,1.1a6.4,6.4,0,0,1,1.7-3.1s-1.4.1-1.7-1.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path class="a" d="M202.1,34.2h-1.2V45.9h1.2Z" transform="translate(-0.1 -0.4)" />
      <path class="c" d="M78.4,245.4h-1v4.9h1Z" transform="translate(-0.1 -0.4)" />
      <path class="c" d="M43.9,226.3h-1v4.8h1Z" transform="translate(-0.1 -0.4)" />
      <path class="a" d="M178.4,14.1l-.6,1,6.2,3.8.7-1.1Z" transform="translate(-0.1 -0.4)" />
      <path class="a" d="M5.2,246.4l-.6,1,6.2,3.7.6-1Z" transform="translate(-0.1 -0.4)" />
      <path class="c" d="M58.2,235.1l-3.9,2.2.6.9,3.8-2.3Z" transform="translate(-0.1 -0.4)" />
      <path class="a" d="M4.8,241.5l-.6,1.1,6.2,3.7.7-1Z" transform="translate(-0.1 -0.4)" />
      <path class="a" d="M174.4,16.3l-.6,1,6.2,3.8.6-1.1Z" transform="translate(-0.1 -0.4)" />
      <path
        class="a"
        d="M34.1,231.3a7,7,0,0,1-1.7,3.1c.2,0,1.5-.2,1.7,1a8.2,8.2,0,0,1,1.7-3.1C35.7,232.3,34.3,232.5,34.1,231.3Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M39.3,228.4a9.1,9.1,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a7,7,0,0,1,1.7-3.1C40.8,229.4,39.5,229.6,39.3,228.4Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M44.3,225.4a7.4,7.4,0,0,1-1.7,3.1c.1,0,1.5-.1,1.7,1.1a6.4,6.4,0,0,1,1.7-3.1s-1.4,0-1.7-1.1S44.3,225.3,44.3,225.4Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M49.5,222.3a6.3,6.3,0,0,1-1.8,3.1c.2,0,1.6-.1,1.8,1.1a5.7,5.7,0,0,1,1.7-3.1s-1.4.1-1.7-1.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M54.6,219.4a6.1,6.1,0,0,1-1.7,3.1c.2,0,1.6-.2,1.7,1a6.9,6.9,0,0,1,1.8-3.1A1.7,1.7,0,0,1,54.6,219.4Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M59.8,216.5a7.7,7.7,0,0,1-1.7,3.1c.2,0,1.5-.2,1.7,1a8.2,8.2,0,0,1,1.7-3.1c-.1,0-1.4.2-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M65,213.4a9.1,9.1,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a6.1,6.1,0,0,1,1.7-3.1A1.4,1.4,0,0,1,65,213.4Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M70.2,210.4a6.3,6.3,0,0,1-1.8,3.1c.2,0,1.6-.1,1.8,1.1a5.7,5.7,0,0,1,1.7-3.1C71.7,211.5,70.3,211.6,70.2,210.4Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M75.3,207.5a6.1,6.1,0,0,1-1.7,3.1c.2,0,1.6-.2,1.7,1a9.1,9.1,0,0,1,1.7-3.1C76.9,208.5,75.5,208.7,75.3,207.5Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M34.1,225.3a7.7,7.7,0,0,1-1.7,3.1c.2,0,1.5-.2,1.7,1a8.2,8.2,0,0,1,1.7-3.1C35.7,226.3,34.3,226.5,34.1,225.3Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M39.3,222.3a7.4,7.4,0,0,1-1.7,3.1c.1,0,1.5-.1,1.7,1.1a6.4,6.4,0,0,1,1.7-3.1C40.8,223.4,39.5,223.5,39.3,222.3Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M44.3,219.4a8.2,8.2,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a7,7,0,0,1,1.7-3.1s-1.4.2-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M49.5,216.5a7.6,7.6,0,0,1-1.8,3.1c.2,0,1.6-.2,1.8,1a6.1,6.1,0,0,1,1.7-3.1s-1.4,0-1.7-1S49.5,216.3,49.5,216.5Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M54.6,213.4a6.6,6.6,0,0,1-1.7,3.1c.2,0,1.6-.2,1.7,1a6.9,6.9,0,0,1,1.8-3.1A1.7,1.7,0,0,1,54.6,213.4Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M59.8,210.4a6.4,6.4,0,0,1-1.7,3.1c.2,0,1.5-.1,1.7,1.1a7.4,7.4,0,0,1,1.7-3.1A1.6,1.6,0,0,1,59.8,210.4Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M65,207.5a8.2,8.2,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a6.6,6.6,0,0,1,1.7-3.1,1.4,1.4,0,0,1-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M34.1,219.4a7,7,0,0,1-1.7,3.1c.2,0,1.5-.2,1.7,1a8.2,8.2,0,0,1,1.7-3.1c-.1,0-1.5.2-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M39.3,216.3a8.2,8.2,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a7,7,0,0,1,1.7-3.1C40.8,217.3,39.5,217.5,39.3,216.3Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M44.3,213.4a9.1,9.1,0,0,1-1.7,3.1c.1,0,1.5-.2,1.7,1a7,7,0,0,1,1.7-3.1s-1.4.2-1.7-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M49.5,210.4a6.3,6.3,0,0,1-1.8,3.1c.2,0,1.6-.1,1.8,1.1a5.7,5.7,0,0,1,1.7-3.1s-1.4.1-1.7-1.1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M54.6,207.5a6.1,6.1,0,0,1-1.7,3.1c.2,0,1.6-.2,1.7,1a7.6,7.6,0,0,1,1.8-3.1s-1.4,0-1.8-1Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M34.1,213.4a7.7,7.7,0,0,1-1.7,3.1c.2,0,1.5-.2,1.7,1a8.2,8.2,0,0,1,1.7-3.1C35.7,214.4,34.3,214.6,34.1,213.4Z"
        transform="translate(-0.1 -0.4)"
      />
      <path
        class="a"
        d="M39.3,210.4a7.4,7.4,0,0,1-1.7,3.1c.1,0,1.5-.1,1.7,1.1a6.4,6.4,0,0,1,1.7-3.1c-.2,0-1.5.1-1.7-1.1Z"
        transform="translate(-0.1 -0.4)"
      />
    </g>
    <g>
      <g class="access-g">
        <path
          class="c"
          d="M57.9,270.8v-4.7l-4.1,2.3L49.3,261c-1.7-1.1-10.5-.2-12.3.8l-3.6,6.9-4.1-2.1v4.7a1.7,1.7,0,0,0,1.2,1.7l10.2,5.7a7.1,7.1,0,0,0,6.2,0l10-5.9A3.5,3.5,0,0,0,57.9,270.8Zm-16.2-4a3.8,3.8,0,0,1,3.3,0l4.6,2.6-1.4.7v1l-8.9.7v-1L37,269.6Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M29.1,272.5a2.2,2.2,0,0,1-.5-1.4v-4.8l.5-.3h.4l3.7,1.9,3.5-6.5h.2c1.9-1.1,10.8-1.9,12.7-.9h.2l4.3,7.2,4-2,.5.3v5c0,.9-.5,1.6-1.6,2.3l-10,5.8a6.8,6.8,0,0,1-6.5,0l-10.2-5.7A2.5,2.5,0,0,1,29.1,272.5Zm.5-5.2v3.8a1.7,1.7,0,0,0,1.1,1.4l10.1,5.7a6.4,6.4,0,0,0,5.7,0l10-5.9a1.6,1.6,0,0,0,1.1-1.3v-3.8l-3.8,2h-.4l-4.3-7.5c-1.7-.6-9.8,0-11.5.9l-3.7,6.9-.3.2-.4-.2Zm7.1,2.6v-.7H37l4.5-2.8a3.7,3.7,0,0,1,3.8,0l5.5,3.1-1.9,1v.2c0,.7,0,1-.5,1l-9.1.7h-.2c-.2-.2-.2-.2-.2-.9v-.2Zm12.1-.5L45,267.2a2.8,2.8,0,0,0-2.8,0l-3.8,2.2,1.6.7c.3.2.3.2.3.9l7.9-.6c0-.7,0-.8.4-.8Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="b"
          d="M40.3,258.9l-10,5.8c-1.7,1.1-1.7,2.6,0,3.5l10.2,5.7a7,7,0,0,0,6,0l10-5.9c1.8-1,1.8-2.6,0-3.4l-10.1-5.7A6,6,0,0,0,40.3,258.9Zm10.4,6.5c.8.6.8,1.4,0,1.9l-5.6,3.3a3.6,3.6,0,0,1-3.2,0l-5.7-3.1a1,1,0,0,1,0-1.9l5.5-3.3a3.8,3.8,0,0,1,3.3,0Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M29.1,267.8a1.9,1.9,0,0,1-.5-1.3,2.8,2.8,0,0,1,1.5-2.3l10-5.8a7,7,0,0,1,6.6,0l10.2,5.7a2.4,2.4,0,0,1,1.5,2.2c0,.9-.5,1.5-1.5,2.2l-10,5.9a7.6,7.6,0,0,1-6.6,0l-10.2-5.7A1.8,1.8,0,0,1,29.1,267.8Zm11.4-8.4-10,5.9a1.4,1.4,0,0,0-1,1.3c0,.6.3.9,1,1.4l10.2,5.7a5.9,5.9,0,0,0,5.5,0l10-5.9a1.4,1.4,0,0,0,1-1.3c0-.5-.3-.9-1-1.4L46,259.4A5.4,5.4,0,0,0,40.5,259.4Zm-5.2,7.9c-.2-.1-.3-.5-.3-.8a1.7,1.7,0,0,1,.8-1.4l5.6-3.3a3.5,3.5,0,0,1,3.7,0l5.7,3.1a1.5,1.5,0,0,1,0,2.8L45.3,271a4.2,4.2,0,0,1-3.8,0l-5.7-3.2Zm15.4-1.9-.2.6-5.7-3.2a4.5,4.5,0,0,0-2.8,0L36.4,266c-.4.1-.4.3-.4.5s.2.3.5.5l5.7,3.1a4.5,4.5,0,0,0,2.8,0l5.5-3.3c.3-.2.5-.3.3-.5s-.1-.3-.5-.5Z"
          transform="translate(-0.1 -0.4)"
        />
        <path class="a" d="M44.1,274.8h-1v4.6h1Z" transform="translate(-0.1 -0.4)" />
        <path class="a" d="M43.9,261.8h-1v4.7H44Z" transform="translate(-0.1 -0.4)" />
        <path class="a" d="M31.8,268.9h-1v4.7h1Z" transform="translate(-0.1 -0.4)" />
        <path class="a" d="M55.3,269.1h-1v4.6h1Z" transform="translate(-0.1 -0.4)" />
        <path
          class="a"
          d="M35.5,267a30,30,0,0,0,2.6,1.5c.1.2,3.8-1.9,3.8-1.9l1.5-.5v-4.3l-2.2.9L36,265.6A6,6,0,0,0,35.5,267Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M43.4,284.4a6.5,6.5,0,0,1-3.6-1l-4.7-2.6.7-1.2,4.7,2.6a6.8,6.8,0,0,0,6.2,0l4.3-2.6.7,1-4.3,2.6A6.5,6.5,0,0,1,43.4,284.4Z"
          transform="translate(-0.1 -0.4)"
        />
      </g>
      <g class="access-g">
        <path
          class="c"
          d="M174.7,189.4l21.9-1.7,3.2,2.2a31.3,31.3,0,0,1,13,3.6,22.1,22.1,0,0,1,3.2,2.3l4-.7v8.3c0,3.4-2.2,7-6.9,9.6-9.3,5.4-24.3,5.4-33.6,0a16.9,16.9,0,0,1-2.8-1.9v-8.3l10.4-1.9-12.4-3.2Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M220.5,203.2v.3c-.2,3.8-2.7,7.3-7.2,9.9-9.5,5.5-24.7,5.5-34.2,0a19.4,19.4,0,0,1-2.9-2.1l-.2-.2v-9l8.3-1.5-9.8-2.6-.4-.2v-9.1l22.5-1.9h.1L200,189a34.1,34.1,0,0,1,13.1,3.7,23.7,23.7,0,0,1,3.3,2.2l3.6-.7h.3l.6.4Zm-45.3-13.3v7.2l11.9,3.1.5.2v1.1l-10.4,1.9v7.4a14.5,14.5,0,0,0,2.6,1.7c9.2,5.2,24,5.2,33,0,4.3-2.4,6.5-5.7,6.5-9.1v-7.6l-3.1.5h-.3l-.2-.2a19,19,0,0,0-3.3-2.2,35.8,35.8,0,0,0-12.7-3.7l-3.3-2Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="b"
          d="M196.2,194.9l-21.5-5.7a20.2,20.2,0,0,1,6.8-5.2c9.2-4.1,22.8-3.8,31.3.9s9.6,14.1.3,19.5-24.3,5.3-33.6,0a16.9,16.9,0,0,1-2.8-1.9Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M220.5,194.9c0,4-2.6,7.6-7.2,10.4-9.5,5.5-24.7,5.5-34.2,0a19.4,19.4,0,0,1-2.9-2.1l-.3-.2v-.7l18.1-7.2-19.8-5.2-.3-.2-.2-.5.2-.2a18.2,18.2,0,0,1,7-5.1c9.5-4.3,23.1-4,31.8.8a19.6,19.6,0,0,1,6,5.2A8.6,8.6,0,0,1,220.5,194.9Zm-24.3-.5.4.2v.8l-19,7.6a10,10,0,0,0,1.9,1.2c9.1,5.2,23.9,5.2,32.9,0,4.3-2.6,6.7-5.8,6.7-9.3s-2.5-6.7-7-9.3c-8.3-4.7-21.6-5-30.7-.9a20.5,20.5,0,0,0-6.1,4.2Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="b"
          d="M176.7,202.7l19.5-7.8L189.5,208a31.9,31.9,0,0,1-10-3.4,10.5,10.5,0,0,1-2.8-1.9Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M189.8,208.7h-.3a36,36,0,0,1-10.2-3.4,15.4,15.4,0,0,1-2.9-2.1l-.4-.2.2-.7,19.8-7.7.4-.2.5.7Zm-10.1-4.5a27.4,27.4,0,0,0,9.4,3.3l5.9-11.4-17.2,6.7A9.4,9.4,0,0,0,179.7,204.2Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M196.2,195.1v13.6a50.4,50.4,0,0,1-6.7-.5Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M181,205.6v8.1c-1.3-.3-3.2-1.9-4.6-2.9v-8.1Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M196.7,209.2h-.5a54.7,54.7,0,0,1-6.9-.5l-.9-.2,7.1-13.8.2-.3.9.2Zm-1.2-1.2V197.3l-5.2,10.2A31.5,31.5,0,0,0,195.5,208Z"
          transform="translate(-0.1 -0.4)"
        />
        <path class="c" d="M196.2,208.7V195.1l4.8,13.3Z" transform="translate(-0.1 -0.4)" />
        <path
          class="a"
          d="M201.7,208.9H201a37.3,37.3,0,0,1-4.8.4h-.5V194.7h1Zm-1.5-1.1-3.5-9.4V208A20.6,20.6,0,0,0,200.2,207.8Z"
          transform="translate(-0.1 -0.4)"
        />
        <path class="a" d="M190,208h-1.2v8.3H190Z" transform="translate(-0.1 -0.4)" />
        <path class="a" d="M215.7,203h-1.2v8.3h1.2Z" transform="translate(-0.1 -0.4)" />
        <path class="a" d="M213.1,205.1h-1.2v8.3h1.2Z" transform="translate(-0.1 -0.4)" />
        <path class="a" d="M180.3,190.8h-1.2V199h1.2Z" transform="translate(-0.1 -0.4)" />
        <path
          class="a"
          d="M184.3,217.5a23.3,23.3,0,0,1-9.5-4.5,4.7,4.7,0,0,1-1.4-2.6v-2.7h-1.2v2.8a4.4,4.4,0,0,0,1.8,3.3,22.2,22.2,0,0,0,10,4.6Z"
          transform="translate(-0.1 -0.4)"
        />
        <path class="a" d="M187,218.1l-.2,1.2,4.4.6.2-1.2Z" transform="translate(-0.1 -0.4)" />
        <path
          class="a"
          d="M196.4,177.3a26.5,26.5,0,0,0-9.5,1l.3,1.3a27.7,27.7,0,0,1,9-1.1Z"
          transform="translate(-0.1 -0.4)"
        />
        <path class="a" d="M185.4,179.1l-3.4,1.3.4,1.1,3.4-1.3Z" transform="translate(-0.1 -0.4)" />
      </g>
      <g class="access-g">
        <path
          class="c"
          d="M97.1,261.6V234.9h2a19,19,0,0,1,6.4-5.7c11.2-6.5,29.5-6.5,40.7,0a19,19,0,0,1,6.4,5.7h2v28.3c-.3,4-3.1,7.6-8.2,10.7-11.2,6.5-29.5,6.5-40.7,0-5.2-3.1-8-6.9-8.3-10.9C97.1,262.8,97.1,261.8,97.1,261.6Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M105,274.4c-5.2-2.9-8.3-7.1-8.8-11.4V234.2h2.4a22,22,0,0,1,6.4-5.5c11.4-6.6,30-6.6,41.4,0a20.8,20.8,0,0,1,6.4,5.5h2.4v29.2c-.4,4.3-3.5,8.1-8.7,11.2s-13.2,5-20.7,5S110.7,277.7,105,274.4Zm48.8-34v-5h-1.7l-.2-.3a19.8,19.8,0,0,0-6.2-5.5c-11.1-6.4-29-6.4-39.9,0a17.7,17.7,0,0,0-6.2,5.5v.3H97.7v27.3c.4,3.8,3.1,7.6,8,10.3,11,6.4,28.9,6.4,39.8,0,5-2.9,7.6-6.2,7.9-10v-.3C153.8,255.3,153.8,240.9,153.8,240.4Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M98.9,234.9a19,19,0,0,1,6.4-5.7,38.1,38.1,0,0,1,16.8-4.6v53.9a42.6,42.6,0,0,1-16.8-4.6c-5.1-3.1-7.9-6.9-8.2-10.9V235.1h1.8Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="b"
          d="M105.3,223.2c-11.2,6.5-11.2,17.1,0,23.4s29.5,6.6,40.7,0,11.2-17,0-23.4S116.7,216.6,105.3,223.2Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M105,247.2c-5.7-3.3-8.8-7.6-8.8-12.5s3.1-9.1,8.8-12.4c11.4-6.5,30-6.5,41.4,0,5.7,3.3,8.8,7.6,8.8,12.4s-3.1,9.2-8.8,12.5a45.3,45.3,0,0,1-41.4,0Zm.8-23.5c-5.1,2.9-8.1,6.9-8.1,11s3,8.1,8.1,11.1c11.1,6.4,29,6.4,39.9,0,5.2-3,8.1-6.9,8.1-11.1s-2.9-8.1-8.1-11a41.9,41.9,0,0,0-20-4.8C118.4,218.9,111.2,220.6,105.8,223.7Z"
          transform="translate(-0.1 -0.4)"
        />
        <path class="a" d="M149.1,244.9h-1v27.3h1Z" transform="translate(-0.1 -0.4)" />
        <path class="a" d="M128.3,251.5h-1.1v27.2h1.1Z" transform="translate(-0.1 -0.4)" />
        <path class="c" d="M116.7,250.6h-.5V277h.5Z" transform="translate(-0.1 -0.4)" />
        <path class="c" d="M98.3,240.4h-.6v26.4h.6Z" transform="translate(-0.1 -0.4)" />
        <path
          class="c"
          d="M110.8,226.3c-8.2,4.8-8.2,12.4,0,17.2s21.6,4.9,29.9,0,8.3-12.4,0-17.2S119,221.5,110.8,226.3Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M110.3,244.1c-4.3-2.5-6.5-5.7-6.5-9.4s2.4-6.9,6.5-9.3c8.5-4.8,22.3-4.8,30.7,0,4.3,2.4,6.6,5.7,6.6,9.3s-2.4,6.9-6.6,9.4-9.8,3.6-15.3,3.6A31.3,31.3,0,0,1,110.3,244.1Zm.9-17.3c-3.8,2.2-5.9,5-5.9,7.9s2.1,5.9,5.9,8c8.1,4.6,21,4.6,29.1,0,3.8-2.3,5.9-5,5.9-8s-2.1-5.8-5.9-7.9a32.8,32.8,0,0,0-29.1,0Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="b"
          d="M110.8,231.1c8.3-4.8,21.6-4.8,29.9,0a11.5,11.5,0,0,1,5.7,6.2,12.9,12.9,0,0,1-5.7,6.2c-8.3,4.9-21.6,4.9-29.9,0-3.1-1.7-5-3.9-5.6-6.2S107.7,232.8,110.8,231.1Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M110.3,244.1a13.3,13.3,0,0,1-6-6.6v-.2h0a12.2,12.2,0,0,1,6-6.6c8.5-4.8,22.3-4.8,30.7,0a12.8,12.8,0,0,1,6.1,6.6h0v.2c-.9,2.6-3,4.8-6.1,6.6s-9.8,3.6-15.3,3.6A31.3,31.3,0,0,1,110.3,244.1Zm30-12.5c-8.1-4.6-21-4.6-29.1,0a12,12,0,0,0-5.4,5.6,12.3,12.3,0,0,0,5.4,5.5c8.1,4.6,21,4.6,29.1,0a12.3,12.3,0,0,0,5.4-5.5A13.1,13.1,0,0,0,140.3,231.6Z"
          transform="translate(-0.1 -0.4)"
        />
        <path class="a" d="M121.5,223h-1v4.8h1Z" transform="translate(-0.1 -0.4)" />
        <path class="a" d="M116.9,224.4h-1.1v4.8h1.1Z" transform="translate(-0.1 -0.4)" />
        <path
          class="a"
          d="M129.6,223v4.5l6.9,1.7,7.5,4.3,2.4,3,.5-3.1-2.9-4.7-4-2.9-5-1.9Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="c"
          d="M121.5,237.7v-.9l.6-.9c.1-.3.3.4.6,0a7.1,7.1,0,0,1,5.7,0c.4.2.6,0,.7.4l.5.3v1.1c0,.5-.5,1-1.2,1.5a6.4,6.4,0,0,1-5.7,0,2.2,2.2,0,0,1-1.2-1.5Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M122.4,239.9a2.6,2.6,0,0,1-1.6-2.1h0v-1.1l.7-1a.8.8,0,0,1,.7-.3h.5a7.7,7.7,0,0,1,6.3.2h.1l.7.3.7.6v1.3a2.5,2.5,0,0,1-1.5,2.1,7,7,0,0,1-3.3.9A5.3,5.3,0,0,1,122.4,239.9Zm6.6-2.7-.4-.4a.6.6,0,0,1-.5-.2,5.5,5.5,0,0,0-5,0,.8.8,0,0,1-.7.2l-.2.2v.7c0,.3.4.7.9,1a5,5,0,0,0,5,0c.3-.2.9-.5.9-.9Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="c"
          d="M122.7,235.1c-1.5.8-1.5,2.4,0,3.3a7.1,7.1,0,0,0,5.7,0c1.6-.9,1.6-2.5,0-3.3A6.4,6.4,0,0,0,122.7,235.1Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M122.4,239a2.3,2.3,0,0,1,0-4.4,7,7,0,0,1,6.6,0,2.4,2.4,0,0,1,0,4.4,6,6,0,0,1-3.3.9A5.3,5.3,0,0,1,122.4,239Zm.7-3.2c-.5.3-.9.7-.9,1s.4.7.9,1a5,5,0,0,0,5,0c.5-.3.9-.6.9-1s-.4-.7-.9-1a5.3,5.3,0,0,0-2.6-.5A5.2,5.2,0,0,0,123.1,235.8Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M129,283.9c8.6-.7,15.8-3.1,21.5-6.9l-.5-.9c-5.5,3.8-12.8,6.1-21,6.8Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M151.9,275.6c3.8-3.3,5.3-6,5.3-6.2l-.8-.5a21,21,0,0,1-5.2,5.8Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="b"
          d="M105.2,256.3l2.7,4.1c1.2.7,4-1.5,4-3.1a5.4,5.4,0,0,0-2.3-4.1l-4.6-2.6c-1.2-.7-4.3,1-4.3,2.8l2,.8C102.9,255.6,103.9,255.6,105.2,256.3Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M107.7,261l-2.9-4.4-.7-.3a2.4,2.4,0,0,1-1.7-2.1l-2.1-.8V253c0-1,1.1-2.1,2.1-2.7a3.9,3.9,0,0,1,3.1-.6l4.7,2.6a6,6,0,0,1,2.4,4.7,4.8,4.8,0,0,1-2.4,3.4,2.9,2.9,0,0,1-1.6.6A1.4,1.4,0,0,1,107.7,261Zm-4.8-9.5a3.6,3.6,0,0,0-1.4,1.3l2.1.7v.4c0,.8.3,1,1.2,1.4l.9.3h.1l2.8,4.1a2.3,2.3,0,0,0,1.2-.3,3.6,3.6,0,0,0,1.9-2.4,4.5,4.5,0,0,0-1.9-3.6l-4.6-2.6h-.4A4.9,4.9,0,0,0,102.9,251.5Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="c"
          d="M103.1,257.7l4.6,2.6c1.2.7,2.3,0,2.3-1.8a5.4,5.4,0,0,0-2.3-4.1l-4.6-2.6c-1.2-.7-2.3,0-2.3,1.7A5.4,5.4,0,0,0,103.1,257.7Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M107.4,260.8l-4.7-2.6a6,6,0,0,1-2.4-4.7,2.3,2.3,0,0,1,1.1-2.2,1.4,1.4,0,0,1,1.9.2l4.6,2.6a5.4,5.4,0,0,1,2.4,4.6,2.5,2.5,0,0,1-1,2.3h-.9A1.9,1.9,0,0,1,107.4,260.8Zm-5.5-8.6c-.4.1-.5.6-.5,1.3a4.5,4.5,0,0,0,1.9,3.7l4.6,2.5c.2.2.7.4.9.2a1.7,1.7,0,0,0,.5-1.4,4.6,4.6,0,0,0-1.9-3.6l-4.7-2.6h-.8Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="b"
          d="M108.3,267.8l-1.2,1.9c1.2.7,3.9-1.5,3.9-3.1a5.3,5.3,0,0,0-2.2-4.1l-.7-.3c-1.2-.7-4.3,1-4.3,2.7l2,.9C106,267,107.1,267.2,108.3,267.8Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M106.9,270.1l-.5-.4,1.2-1.9s-.2,0-.2-.1-1.6-.7-1.7-2.1l-2.1-.9v-.3c0-1,1-2.1,2.1-2.8a4.2,4.2,0,0,1,3.1-.5l.7.4a5.7,5.7,0,0,1,2.4,4.6,4.3,4.3,0,0,1-2.4,3.3,3.7,3.7,0,0,1-1.6.5C107.2,270.3,107.1,270.3,106.9,270.1Zm-1.1-7.3a4,4,0,0,0-1.3,1.4l2,.7v.4c0,.8.4,1,1.2,1.3s.6.2.9.4l.5.3-1,1.8c.2,0,.3-.2.7-.4a3.6,3.6,0,0,0,1.9-2.4,4.5,4.5,0,0,0-1.9-3.6l-.7-.4h-.4A4.9,4.9,0,0,0,105.8,262.8Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="c"
          d="M106,269.1l.7.3c1.2.7,2.2,0,2.2-1.7a5.3,5.3,0,0,0-2.2-4.2l-.7-.3c-1.2-.7-2.2,0-2.2,1.7A5.2,5.2,0,0,0,106,269.1Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M106.4,269.9l-.7-.3a5.8,5.8,0,0,1-2.4-4.7,2.3,2.3,0,0,1,1-2.2,1.5,1.5,0,0,1,1.9.1l.7.4a5.7,5.7,0,0,1,2.4,4.6,2.7,2.7,0,0,1-1,2.3,1.3,1.3,0,0,1-.9.2Zm-1.6-6.2a1.7,1.7,0,0,0-.5,1.4,4.5,4.5,0,0,0,1.9,3.6l.7.4c.2.1.5.3.8.1s.6-.7.6-1.4a4.6,4.6,0,0,0-1.9-3.6l-.7-.3a.6.6,0,0,0-.5-.2C105,263.5,105,263.5,104.8,263.7Z"
          transform="translate(-0.1 -0.4)"
        />
      </g>
      <g class="access-g">
        <path
          class="b"
          d="M214.1,65.7l-6.9-4.4v-.2L216,50.4h.2l1.4,6.5.3,4.5v.2l-3.8,4.1Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M213.8,66.3l-6.9-4.5a.9.9,0,0,1-.3-.7v-.4l8.9-11c.2-.3.5-.3.9-.3h.5l1.6,6.9.3,4.7v.3L215,65.9c-.2.2-.3.4-.7.4A.5.5,0,0,1,213.8,66.3Zm3.1-9.2-1.2-5.2-7.6,9.2,5.9,3.8,3.1-3.6Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="b"
          d="M187.9,33.3,221,14.2a3.3,3.3,0,0,1,2.3-.4l6.5,3.8c.2,0,.2.2,0,.4l-7.7,8.1V39.7a7.6,7.6,0,0,1-3.5,5.9l-5,2.9a1.3,1.3,0,0,0-.3.5,18.1,18.1,0,0,1-7.8,11.6c-.2.1-.3,0-.2-.4s2.3-4.8,1.9-7.4c-.1-.2-.3-.2-.5-.2l-10.1,5.9v.2l-4.4,11.4a.1.1,0,0,1-.1.1l-6.4-3.8a2.3,2.3,0,0,1-.9-2v-25A6.8,6.8,0,0,1,187.9,33.3Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M185,67a3.1,3.1,0,0,1-1.2-2.8V39.4a8.3,8.3,0,0,1,3.8-6.6l33.1-19.1a3.4,3.4,0,0,1,2.9-.4l6.4,3.8a1.8,1.8,0,0,1,.5.7,1.5,1.5,0,0,1-.1.7l-7.6,7.9V39.7a8.7,8.7,0,0,1-3.8,6.6L214.1,49v.2a19.2,19.2,0,0,1-8,11.9,1.3,1.3,0,0,1-1.2,0,1.4,1.4,0,0,1-.1-1.4,16.2,16.2,0,0,0,1.9-6.4l-9.5,5.5-4.2,11.3c-.1.1-.3.5-.5.5h-.5Zm22.9-14.5v.3c.4,1.9-.3,4.1-1,5.9a17.4,17.4,0,0,0,5.5-9.7l.5-.8,5.2-3.1a6.6,6.6,0,0,0,2.9-5.2V26.1l7.5-8-5.7-3.4c-.4-.2-.9,0-1.6.3L188.1,34.2a6.5,6.5,0,0,0-2.9,5.2V64.2c0,.7.1,1.2.5,1.4l5.9,3.4,3.9-10.7.2-.3,10.7-6.2Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M194.5,37.5l33.3-19.2c1.9-1,3.2-.2,3.2,1.9v25a7.4,7.4,0,0,1-3.2,5.7l-5.2,2.9c-.2,0-.2.2-.2.4a17.4,17.4,0,0,1-7.7,11.5c-.2.2-.4,0-.2-.3s2.4-5,1.7-7.6c0-.2-.2-.2-.3-.2L194.5,70.1c-1.9,1-3.3.1-3.3-1.9v-25A7,7,0,0,1,194.5,37.5Z"
          transform="translate(-0.1 -0.4)"
        />
        <path
          class="a"
          d="M191.7,70.9a3.2,3.2,0,0,1-1.4-2.7v-25a7.8,7.8,0,0,1,3.7-6.4l33.2-19.2a2.9,2.9,0,0,1,3.2-.1,3.1,3.1,0,0,1,1.3,2.7v25a7.9,7.9,0,0,1-3.6,6.4l-5,2.9a19.2,19.2,0,0,1-7.9,12.1,1.3,1.3,0,0,1-1.2,0,1.2,1.2,0,0,1-.2-1.4,14.3,14.3,0,0,0,1.9-6.4L195,70.7a3.5,3.5,0,0,1-1.9.6A1.8,1.8,0,0,1,191.7,70.9Zm24.7-14,.5.4.2.3c.5,2.1-.2,4.4-.9,6.2a16,16,0,0,0,5.5-9.6c0-.4.4-.7.7-.9l5.2-2.9a6.9,6.9,0,0,0,2.9-5V20.2a1.7,1.7,0,0,0-.5-1.5,1.6,1.6,0,0,0-1.5.1L195.2,38a6.5,6.5,0,0,0-3,5V68a1.8,1.8,0,0,0,.6,1.5,1.6,1.6,0,0,0,1.5-.1l21.4-12.5h.5C216,56.9,216.2,56.9,216.4,56.9Z"
          transform="translate(-0.1 -0.4)"
        />
        <path class="a" d="M218.6,15.7l-.8,1.4,5.7,3.5.8-1.4Z" transform="translate(-0.1 -0.4)" />
        <path class="a" d="M185.2,39.9l-.8,1.3,6.4,4,.8-1.3Z" transform="translate(-0.1 -0.4)" />
        <path class="a" d="M184.5,44l6.7,4V69.7l-6.4-3.4-.3-1.6Z" transform="translate(-0.1 -0.4)" />
        <path
          class="b"
          d="M221.2,37.6l-6.7-3.8a1.1,1.1,0,0,0-1.1.2l-1,1c-.5,1.1-.5,2.1,0,2.5l4.3,2.4-11.2,6.5a3.2,3.2,0,0,0-1.4,2.4c0,.9.7,1.3,1.4.9l11.2-6.5-4.1,7.2c-.5,1-.5,2.1,0,2.4a.7.7,0,0,0,1-.2c.4-.1.7-.5,1.1-1l6.7-11.5C221.7,39,221.7,37.8,221.2,37.6Z"
          transform="translate(-0.1 -0.4)"
        />
        <g>
          <path class="a" d="M220.9.5h-1.5l.6,7.2h1.5Z" transform="translate(-0.1 -0.4)" />
          <path class="a" d="M228.2.4l-3.4,7.7,1.5.6L229.6,1Z" transform="translate(-0.1 -0.4)" />
          <path class="a" d="M235.4,6.9l-6,3.4.8,1.3,6-3.4Z" transform="translate(-0.1 -0.4)" />
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
import coords from "@/components/coords.js";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";
import { mapState } from "vuex";

gsap.registerPlugin(ScrollTrigger);

export default {
  computed: {
    ...mapState(["toggleConfig", "startConfig", "isAnimationDisabled", "viewportSize"]),
  },
  mixins: [coords],
  props: {
    x: {
      type: [Number, String],
      default: 1200,
    },
    y: {
      type: [Number, String],
      default: 50,
    },
    xSmall: {
      type: [Number, String],
      default: 1200,
    },
    ySmall: {
      type: [Number, String],
      default: 50,
    },
  },
  methods: {
    redirectAnim() {
      gsap.set(".computer, .access g", {
        transformOrigin: "50% 50%",
      });

      gsap
        .timeline({
          scrollTrigger: {
            trigger: "#milestone-redirect",
            toggleActions: this.toggleConfig,
            start: this.startConfig,
          },
        })
        .add("redirect")
        .fromTo(
          ".computer",
          {
            duration: 0.5,
            opacity: 0,
            scale: 0.9,
            transformOrigin: "50% 50%",
          },
          {
            opacity: 1,
            scale: 1,
            stagger: 0.05,
            ease: "back.out(1.7)",
          },
          "redirect"
        )
        .from(
          ".access-g",
          {
            duration: 1,
            opacity: 0,
            scale: 0,
            rotation: -180,
            stagger: 0.3,
            ease: "back.out(1.7)",
            transformOrigin: "50% 50%",
          },
          "redirect"
        );
    },
  },
  mounted() {
    this.redirectAnim();
  },
};
</script>

<style lang="scss" scoped>
.a {
  fill: #0e1e25;
}
.b {
  fill: #fff;
}
.c {
  fill: #ffad43;
}
</style>
